(function (angular) {
	'use strict';

	angular
		.module('serviceLevelModule')
		.controller('ViewNewAllocation', [
			'$filter',
			'$window',
			'CheckoutFactory',
			'InvestmentEntityFactory',
			'INVESTMENT_ENTITY_ID',
			'planFactory',
			'urlFactory',
			ViewNewAllocation
		]);

	function ViewNewAllocation(
		$filter,
		$window,
		CheckoutFactory,
		InvestmentEntityFactory,
		INVESTMENT_ENTITY_ID,
		planFactory,
		urlFactory
	) {
		var viewNewAllocation = this;

		function buildPayload() {			
			var payload = {
				amount: viewNewAllocation.amount,
				paymentMethodId: viewNewAllocation.paymentMethodId,
				riaPlanId: viewNewAllocation.riaPlanId,
				serviceLevelUpgrade: viewNewAllocation.serviceLevelUpgrade
			};

			return payload;
		}

		function getOrderAllocation() {
			var urlParams = {
				amount: viewNewAllocation.amount,
				riaPlanId: viewNewAllocation.riaPlanId
			};
			
			var baseUrl = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investment/allocation';
			var formattedUrl = urlFactory.serializeParamsAndCreateUrl(baseUrl, urlParams);

			return urlFactory.apiGetPromise(formattedUrl);
		}

		function getPlanData() {
			return planFactory.getPlanData(['STANDARD', 'STANDARD_PLUS']);
		}

		function submitInvestAndUpgrade() {
			var payload = buildPayload();
			CheckoutFactory.createOrderGroup(payload)
				.then(function(response) {
					viewNewAllocation.reitInvestmentOrderGroupId = response.orderGroupId;
					urlFactory.submitFormById('successfulSubmissionForm');
				});
		}

		viewNewAllocation.back = function() {
			$window.history.back();
		};

		viewNewAllocation.continue = function() {
			submitInvestAndUpgrade();
		};

		viewNewAllocation.$onInit = function() {
			angular.extend(viewNewAllocation, globalConfig);

			InvestmentEntityFactory.getEntityOverview()
				.then(function(entityOverview) {
					viewNewAllocation.investmentEntityInfo = entityOverview;
				});

			getOrderAllocation()
				.then(function(response) {
					viewNewAllocation.orderAllocation = response.data;
				});
			
			getPlanData()
				.then(function(response) {
					viewNewAllocation.riaPlan = $filter('filter')(response.data, {'planId': viewNewAllocation.riaPlanId}, true)[0];
				});
			};
	}
})(window.angular);